import React from 'react';
import { useSelector } from 'react-redux';

import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Flex,
  Icon,
  Skeleton,
} from '@chakra-ui/react';

import { FaFile, FaDatabase, FaCloudUploadAlt, FaClock } from 'react-icons/fa';

import { useColors } from './colors';

const SummaryStats = () => {
  const { textColor, backgroundCardColor, secondaryTextColor } = useColors();

  const { overview, getOverviewStatus } = useSelector((state) => state.inventories);


  const stats = [
    {
      label: 'Total Inventory Files',
      value: overview.totalInventories,
      icon: FaFile,
      helpText: 'All time',
    },
    {
      label: 'Total Storage Size',
      value: overview.totalStorageSize,
      icon: FaDatabase,
    },
    {
      label: "Today's Uploads",
      value: overview.currentDayInventories,
      icon: FaCloudUploadAlt,
    },
    {
      label: 'Pending Chunking',
      value: overview.pendingChunking,
      icon: FaClock,
    },
  ];

  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6} mb={8}>
      {stats.map((stat, index) => (
        <Box key={index} p={6} bg={backgroundCardColor} borderRadius="lg" boxShadow="sm">
          <Flex justify="space-between" align="center">
            <Stat>
              <StatLabel color={textColor} fontSize="sm">
                {stat.label}
              </StatLabel>
              <Skeleton isLoaded={getOverviewStatus !== 'pending'}>
                <StatNumber color={textColor} fontSize="2xl">
                  {stat.value}
                </StatNumber>
              </Skeleton>
              {stat.helpText && (
                <StatHelpText color={secondaryTextColor}>{stat.helpText}</StatHelpText>
              )}
            </Stat>
            <Icon as={stat.icon} boxSize={8} color="blue.500" />
          </Flex>
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default SummaryStats;
